import { gql } from '@apollo/client';

export const ADD_LEAVE_MUTATION = gql`
  mutation addLeave($id: ID!, $input: AddorEditLeaveInput) {
    addLeave(id: $id, input: $input) {
      id
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const UPDATE_LEAVE_MUTATION = gql`
  mutation updateLeave($id: ID!, $input: AddorEditLeaveInput) {
    updateLeave(id: $id, input: $input) {
      id
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const DELETE_LEAVE_MUTATION = gql`
  mutation deleteLeave($id: ID!) {
    deleteLeave(id: $id) {
      id
    }
  }
`;

export const ADD_ALLOWANCE_MUTATION = gql`
  mutation addAllowance($id: ID!, $input: AddorEditAllowanceInput) {
    addAllowance(id: $id, input: $input) {
      id
      for_month
      note
      amount
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const UPDATE_ALLOWANCE_MUTATION = gql`
  mutation updateAllowance($id: ID!, $input: AddorEditAllowanceInput) {
    updateAllowance(id: $id, input: $input) {
      id
      for_month
      note
      amount
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const DELETE_ALLOWANCE_MUTATION = gql`
  mutation deleteAllowance($id: ID!) {
    deleteAllowance(id: $id) {
      id
    }
  }
`;

export const ADD_DEDUCTION_MUTATION = gql`
  mutation addDeduction($id: ID!, $input: AddorEditDeductionInput) {
    addDeduction(id: $id, input: $input) {
      id
      for_month
      note
      amount
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const UPDATE_DEDUCTION_MUTATION = gql`
  mutation updateDeduction($id: ID!, $input: AddorEditDeductionInput) {
    updateDeduction(id: $id, input: $input) {
      id
      for_month
      note
      amount
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const DELETE_DEDUCTION_MUTATION = gql`
  mutation deleteDeduction($id: ID!) {
    deleteDeduction(id: $id) {
      id
    }
  }
`;

export const ADD_ADVANCE_MUTATION = gql`
  mutation addAdvance($id: ID!, $input: AddorEditAdvanceInput) {
    addAdvance(id: $id, input: $input) {
      id
      for_month
      note
      amount
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const UPDATE_ADVANCE_MUTATION = gql`
  mutation updateAdvance($id: ID!, $input: AddorEditAdvanceInput) {
    updateAdvance(id: $id, input: $input) {
      id
      for_month
      note
      amount
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const DELETE_ADVANCE_MUTATION = gql`
  mutation deleteAdvance($id: ID!) {
    deleteAdvance(id: $id) {
      id
    }
  }
`;

export const ADD_ADVANCE_DEDUCTION_MUTATION = gql`
  mutation addAdvanceDeduction(
    $id: ID!
    $input: AddorEditAdvanceDeductionInput
  ) {
    addAdvanceDeduction(id: $id, input: $input) {
      id
      amount
      note
      for_month
      advance_id
      advance {
        id
        employee_id
        employee {
          id
          first_name
        }
      }
    }
  }
`;

export const UPDATE_ADVANCE_DEDUCTION_MUTATION = gql`
  mutation updateAdvanceDeduction(
    $id: ID!
    $input: AddorEditAdvanceDeductionInput
  ) {
    updateAdvanceDeduction(id: $id, input: $input) {
      id
      amount
      note
      for_month
      advance_id
      advance {
        id
        employee_id
        employee {
          id
          first_name
        }
      }
    }
  }
`;

export const DELETE_ADVANCE_DEDUCTION_MUTATION = gql`
  mutation deleteAdvanceDeduction($id: ID!) {
    deleteAdvanceDeduction(id: $id) {
      id
      advance_id
    }
  }
`;

export const IMPORT_INCENTIVE_MUTATION = gql`
  mutation ImportIncentive($input: IncentiveImportInput) {
    importIncentive(input: $input) {
      id
      for_month
      records_processed
      portfolio_id
      portfolio {
        id
        name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const DELETE_INCENTIVE_IMPORT_MUTATION = gql`
  mutation deleteIncetiveImport($id: ID!) {
    deleteIncentiveImport(id: $id) {
      id
    }
  }
`;

export const ADD_CONVEYANCE_MUTATION = gql`
  mutation addConveyance($id: ID!, $input: AddorEditConveyanceInput) {
    addConveyance(id: $id, input: $input) {
      id
      conveyance_type_id
      conveyance_type {
        id
        name
      }
      employee_id
      employee {
        id
        emp_id
        first_name
        last_name
      }
      effective_from
      note
      createdBy {
        id
        name
      }
    }
  }
`;

export const UPDATE_CONVEYANCE_MUTATION = gql`
  mutation reviseConveyance($id: ID!, $input: AddorEditConveyanceInput) {
    reviseConveyance(id: $id, input: $input) {
      id
      conveyance_type_id
      conveyance_type {
        id
        name
      }
      employee_id
      employee {
        id
        emp_id
        first_name
        last_name
      }
      effective_from
      note
      createdBy {
        id
        name
      }
    }
  }
`;

export const DELETE_CONVEYANCE_MUTATION = gql`
  mutation deleteConveyance($id: ID!) {
    deleteConveyance(id: $id) {
      id
    }
  }
`;

export const GENERATE_PAYSLIP_MUTATION = gql`
  mutation generatePayslips($input: PayslipGenerateInput) {
    generatePayslips(input: $input) {
      statusCode
      message
      errorMessage
    }
  }
`;

export const REFRESH_PAYSLIP_MUTATION = gql`
  mutation RefreshPayslipById($id: ID!) {
    refreshPayslipById(id: $id) {
      id
      for_month
      leave_adjusted
      tax_percentage
      conveyance
      conveyanceAdjusted
      totalIncentive
      totalAllowance
      totalDeduction
      taxDeduction
      totalEarning
      netEarning
      note
    }
  }
`;

export const ADD_PAYMENT_MUTATION = gql`
  mutation addPayment($id: ID!, $input: AddorEditPaymentInput) {
    addPayment(id: $id, input: $input) {
      id
      for_month
      note
      amount
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const UPDATE_PAYMENT_MUTATION = gql`
  mutation updatePayment($id: ID!, $input: AddorEditPaymentInput) {
    updatePayment(id: $id, input: $input) {
      id
      for_month
      note
      amount
      employee {
        id
        first_name
        last_name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export const DELETE_PAYMENT_MUTATION = gql`
  mutation deletePayment($id: ID!) {
    deletePayment(id: $id) {
      id
    }
  }
`;

export const IMPORT_PAYMENTS_MUTATION = gql`
  mutation ImportPayment($input: PaymentImportInput) {
    importPayments(input: $input) {
      id
      for_month
      records_processed
      createdBy {
        id
        name
      }
    }
  }
`;
